"use strict";

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

function splitSelectorFilterFactory() {
  return function (combinedFilter) {
    var _combinedFilter$split = combinedFilter.split(" as ").map(function (x) {
      return x.trim();
    }),
        _combinedFilter$split2 = _slicedToArray(_combinedFilter$split, 2),
        selector = _combinedFilter$split2[0],
        replacement = _combinedFilter$split2[1];

    return {
      selector: selector,
      replacement: replacement
    };
  };
}

exports.splitSelectorFilterFactory = splitSelectorFilterFactory;